import './styles/aui.pattern.messages';
import { MessageEl } from '@atlassian/aui/src/js/aui/messages';
export { MessageEl };
